// extracted by mini-css-extract-plugin
export default {"container":"InputPromo_container__3f+PZ","container_input":"InputPromo_container_input__A3pJq","container_button":"InputPromo_container_button__BODvG"};